import { render, staticRenderFns } from "./Geo.vue?vue&type=template&id=380b3c56&"
import script from "./Geo.vue?vue&type=script&lang=js&"
export * from "./Geo.vue?vue&type=script&lang=js&"
import style0 from "./Geo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports